import React from "react";
import { TContainerStateProps } from "../state/TContainerStateProps";
import { FrontPage } from "../components/Front/Simple/FrontPage/FrontPage";
import { SpacingRow } from "../components/BuildingBlocks/SpacingRow";
import { MaxWidth } from "../components/BuildingBlocks/MaxWidth";
import FrontAuthenticatorCardContainer from "../containers/Front/FrontAuthenticatorCardContainer";

const FrontAuthenticatorPage = (props: TContainerStateProps): JSX.Element =>
    <FrontPage>
        <SpacingRow
            justifyContent="center"
            alignItems="flex-start"
        >
            <MaxWidth width="670px">
                {props.state.forms.authenticator_page.status !== "untouched" && <FrontAuthenticatorCardContainer {...props}/>}
            </MaxWidth>
        </SpacingRow>
    </FrontPage>;

export default FrontAuthenticatorPage;
